// device detection for setting 100vh heights properly in CSS, just like on warp.net, but better :D

// tslint:disable-next-line:max-line-length
const userAgent = navigator.userAgent || navigator.vendor || window.opera
const maxTouchPoints = navigator.maxTouchPoints || navigator.msMaxTouchPoints || 0
const isTouchUA = /(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/.test(userAgent)
// iPadOS in desktop mode reports as Macintosh, so use touch points
const isIpadOS = /Macintosh/.test(userAgent) && maxTouchPoints > 1
const isTouchDevice = isTouchUA || isIpadOS

const touchDeviceClass = isTouchDevice ? 'is-touchdevice' : 'no-touchdevice'
jQuery('body').addClass(touchDeviceClass)

const iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent)

// Get the device pixel ratio
const ratio = window.devicePixelRatio || 1

// Define the users device screen dimensions
const screen = {
	width: window.screen.width * ratio,
	height: window.screen.height * ratio,
}

// is iPad, iOS 13. iOS 13's iPad's user agent does not contain "iPad" but acts like a Macintosh
let isiOS13iPad_Macintosh_regexResult = navigator.userAgent.match(/(Macintosh)/)
const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)
let isiOS13iPad = false
if (isiOS13iPad_Macintosh_regexResult === null) {
	isiOS13iPad_Macintosh_regexResult = false
} else {
	isiOS13iPad_Macintosh_regexResult = true
}

let isiPadRecognizedBySize = false
let isiPadWithoutHomeButton = false

// iPad Pro 12.9 inches 2018 (no homebutton)
if (screen.width == 2048 && screen.height == 2732) {
	isiPadRecognizedBySize = true
	isiPadWithoutHomeButton = true
}
// iPad Pro 11 inches 2018 (no homebutton)
if (screen.width == 1668 && screen.height == 2388) {
	isiPadRecognizedBySize = true
	isiPadWithoutHomeButton = true
}
// iPad Pro 12.9 inches 2017 (with homebutton)
if (screen.width == 2732 && screen.height == 2048) {
	isiPadRecognizedBySize = true
}
// iPad Pro 9.7 inches 2016 (with homebutton)
if (screen.width == 1536 && screen.height == 2048) {
	isiPadRecognizedBySize = true
}
// iPad 7th Generation (with homebutton)
if (screen.width == 1620 && screen.height == 2160) {
	isiPadRecognizedBySize = true
}
// iPad 6th Generation (with homebutton)
if (screen.width == 1536 && screen.height == 2048) {
	isiPadRecognizedBySize = true
}

if (isiOS13iPad_Macintosh_regexResult == true && isSafari == true && isiPadRecognizedBySize) {
	isiOS13iPad = true
}

if (iOS === true || isiOS13iPad) {
	document.documentElement.classList.add('is-ios')
} else {
	document.documentElement.classList.add('no-ios')
}

const iPad = /(iPad)/g.test(navigator.userAgent)
if (iPad === true || isiOS13iPad) {
	if (isiPadWithoutHomeButton) {
		document.documentElement.classList.add('is-ipad-without-homebutton')
	} else {
		document.documentElement.classList.add('is-ipad')
	}
} else {
	document.documentElement.classList.add('no-ipad')
}

// iphone x
// https://stackoverflow.com/questions/47226824/iphonex-and-notch-detection

const iPhone = /(iPhone)/g.test(navigator.userAgent)

// todo: do it the other way around, just look for the older iphones, and when current iphone isn't old
// then say it is an iphone without a homebutton by default
// this way we don't have to add new tests for new iphones

// https://www.ios-resolution.com/
let iphone_resolutions = [
	{
		name: 'iPhone 14 Plus',
		w: 1284,
		h: 2778,
	},
	{
		name: 'iPhone 14 Pro Max',
		w: 1290,
		h: 2796,
	},
	{
		name: 'iPhone 14 Pro',
		w: 1179,
		h: 2556,
	},
	{
		name: 'iPhone 14',
		w: 1170,
		h: 2532,
	},
	// iphone se has a homebutton!!!
	// {
	//     name: 'iPhone SE 3rd gen',
	//     w: 750,
	//     h: 1334
	// },
	{
		name: 'iPhone 13',
		w: 1170,
		h: 2532,
	},
	{
		name: 'iPhone 13 mini',
		w: 1080,
		h: 2340,
	},
	{
		name: 'iPhone 13 Pro Max',
		w: 1284,
		h: 2778,
	},
	{
		name: 'iPhone 13 Pro',
		w: 1170,
		h: 2532,
	},
	{
		name: 'iPhone 12',
		w: 1170,
		h: 2532,
	},
	{
		name: 'iPhone 12 mini',
		w: 1080,
		h: 2340,
	},
	{
		name: 'iPhone 12 Pro Max',
		w: 1284,
		h: 2778,
	},
	{
		name: 'iPhone 12 Pro',
		w: 1170,
		h: 2532,
	},
	// iphone se has a homebutton!!!
	// {
	//     name: 'iPhone SE 2nd gen',
	//     w: 750,
	//     h: 1334
	// },
	{
		name: 'iPhone 11 Pro Max',
		w: 1242,
		h: 2688,
	},
	{
		name: 'iPhone 11 Pro',
		w: 1125,
		h: 2436,
	},
	{
		name: 'iPhone 11',
		w: 828,
		h: 1792,
	},
	{
		name: 'iPhone XR',
		w: 828,
		h: 1792,
	},
	{
		name: 'iPhone XS Max',
		w: 1242,
		h: 2688,
	},
	{
		name: 'iPhone XS',
		w: 1125,
		h: 2436,
	},
	{
		name: 'iPhone X',
		w: 1125,
		h: 2436,
	},
]

var isNewIphone = false
if (iOS === true) {
	for (var i = 0; i < iphone_resolutions.length; i++) {
		var obj = iphone_resolutions[i]
		if (screen.width === obj.w && screen.height === obj.h) {
			isNewIphone = true
			break
		}
	}
}

// iPhone X Detection, this is just to detect iphones that have no home-buttons
// because their safari barheight is different from the older iphones
// iphonex, xr and so on is not part of the navigator.userAgent, so we're just looking at screen widths and heights
if (isNewIphone) {
	// actually it is iphone11 or iphone11 max pro or iphonex
	document.documentElement.classList.add('is-iphone-no-homebutton')
} else if (iPhone === true) {
	// iphone with homebutton
	document.documentElement.classList.add('is-iphone')
} else {
	document.documentElement.classList.add('no-iphone')
}

// https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome/13348618#13348618
// please note,
// that IE11 now returns undefined again for window.chrome
// and new Opera 30 outputs true for window.chrome
// but needs to check if window.opr is not undefined
// and new IE Edge outputs to true now for window.chrome
// and if not iOS Chrome check
// so use the below updated condition
const isChromium = window.chrome
const winNav = window.navigator
const vendorName = winNav.vendor
const isOpera = typeof window.opr !== 'undefined'
const isIEedge = winNav.userAgent.indexOf('Edge') > -1
const isIOSChrome = winNav.userAgent.match('CriOS')
// browser should only be either chrome or safari. not both. if i use chrome and simulate a iphone-x with it,
// it would add both is-safari and is-chrome if I did not user browser = '...' and instead would just add a class directly to html dom element
let browser = 'no-chrome-no-safari'

if (isIOSChrome) {
	// is Google Chrome on IOS
	browser = 'is-chrome'
} else if (isChromium !== null && typeof isChromium !== 'undefined' && vendorName === 'Google Inc.' && isOpera === false && isIEedge === false) {
	// is Google Chrome
	browser = 'is-chrome'
} else {
	// not Google Chrome
}

const ua = navigator.userAgent.toLowerCase()
const isAndroid = ua.indexOf('android') > -1 // && ua.indexOf('mobile');
if (isAndroid === true) {
	document.documentElement.classList.add('is-android')
}

// Firefox detection
const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1

if (isSafari === true) {
	browser = 'is-safari'
} else if (isFirefox === true) {
	browser = 'is-firefox'
}

if (!isFirefox) {
	document.documentElement.classList.add('no-firefox')
}

document.documentElement.classList.add(browser)
if (browser != 'is-chrome') {
	document.documentElement.classList.add('no-chrome')
}
// #device detection

var ua2 = (navigator.userAgent || navigator.vendor || window.opera).toLowerCase()
var isInstagram = ua2.indexOf('instagram') > -1 ? true : false

if (isInstagram) {
	document.documentElement.classList.add('is-instagram-browser')
} else {
	document.documentElement.classList.add('no-instagram-browser')
}
